import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const saveNewAbstractCourseOperation = async (
  courseName: string,
  courseHours: number,
  attendanceRequire: number,
  majorIds: number[],
  setLoading: (isLoading: boolean) => void,
  onHide: () => any,
) => {
  try {
    if (!courseName && courseName.length === 0) {
      toast.warn(`יש להזין שם הקורס`);
      console.warn(`Course name must not be empty`);
      return;
    }
    if (isNaN(Number(courseHours)) || isNaN(Number(attendanceRequire))) {
      console.warn(
        `saveNewAbstractCourseOperation courseHours: ${courseHours} and attendanceRequire: ${attendanceRequire} must be a number`,
      );
      toast.warn('שעות הקורס ואחוז הנוכחות חייבים להיות תקינים');
      return;
    }
    const existingAbstractCourses = globalSettingsStores.abstractCourses.find(
      (item) => item.courseName === courseName,
    );
    /*if (existingAbstractCourses) {
      toast.warn('שם קורס טיפוסי קיים במערכת');
      return;
    }*/

    if (courseName && courseName.length > 50) {
      toast.warn('על קורס טיפוסי להיות באורך של לא יותר מחמישים תווים');
    }

    setLoading(true);
    const newAbstractCourse = await appApi.addAbstractCourse(
      courseName,
      Number(courseHours),
      Number(attendanceRequire),
      majorIds,
    );
    globalSettingsStores.fetchSetting();
    /*if (newAbstractCourse?.data.ok) {
      globalSettingsStores.abstractCourses.push(newAbstractCourse.data.body);
    }*/

    setLoading(false);

    toast.success(`הוספת ${courseName} התבצעה בהצלחה`);
    onHide();
    return;
  } catch (e) {
    setLoading(false);
    toast.error('יצירת הקורס נכשלה, נסה שוב בעוד מספר רגעים');
    console.error(
      `saveNewAbstractCourseOperation is failed with the course name: ${courseName} and the error: ${e}`,
    );
  }
};
